module.exports = __webpack_public_path__ + "fonts/AkkIt_Pro_1.fca60fc.otf";